import { ChevronDownIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuDivider,
  MenuGroup,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import { useIntl } from "react-intl";

export interface LayerSwitcherProps {
  layers: {
    layer: string;
    description: string;
  }[];
  currentLayer: string | null;
  setLayer: (layer: string | null) => void;
  baselayers: {
    key: string;
    description: string;
  }[];
  currentBaselayer: string | null;
  setBaselayer: (layer: string | null) => void;
}

export function LayerSwitcher({
  layers,
  currentLayer,
  setLayer,
  baselayers,
  currentBaselayer,
  setBaselayer,
}: LayerSwitcherProps) {
  const intl = useIntl();
  const currentDescription =
    layers.find((layer) => layer.layer === currentLayer)?.description ??
    intl.formatMessage({ id: "layerswitcher.default_description", defaultMessage: "Layers" });

  return (
    <Box position="absolute" top="0" p="8px">
      <Menu>
        <MenuButton as={Button} bgColor="white" variant="outline" rightIcon={<ChevronDownIcon />}>
          {currentDescription}
        </MenuButton>

        <MenuList>
          <MenuGroup
            title={intl.formatMessage({
              id: "layerswitcher.rasterlayers",
              defaultMessage: "Raster layers",
            })}
          >
            {layers.map((layer) => (
              <MenuItem
                key={layer.layer}
                onClick={() => setLayer(layer.layer === currentLayer ? null : layer.layer)}
                textDecoration={layer.layer === currentLayer ? "underline" : ""}
              >
                {layer.description}
              </MenuItem>
            ))}
          </MenuGroup>
          <MenuDivider />
          <MenuGroup
            title={intl.formatMessage({
              id: "layerswitcher.baselayers",
              defaultMessage: "Base layers",
            })}
          >
            {baselayers.map((layer) => (
              <MenuItem
                key={layer.key}
                onClick={() => setBaselayer(layer.key)}
                textDecoration={layer.key === currentBaselayer ? "underline" : ""}
              >
                {layer.description}
              </MenuItem>
            ))}
          </MenuGroup>
        </MenuList>
      </Menu>
    </Box>
  );
}
